import { Component } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";
import * as Enums from "../../../app/access-control/access-control-constant";
import { AccessControlService } from "../../../app/access-control/access-control-service";
import { PATIENT_ORDER_MANAGEMENT_CLINICAL_ADMIN } from "../../../app/access-control/common-permission-asks";
import { OrderManagement } from "../../../app/access-control/permissions";
import { PermissionsResponse } from "../../../app/access-control/permissions-response";

/**
 * Generated class for the OrderPopupComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: "order-popup",
  templateUrl: "order-popup.html",
})
export class OrderPopupComponent {
  config: any;
  id: any;
  revision: any;
  status: any;
  enums = Enums;
  permissionsAccess = {} as PermissionsResponse;

  constructor(
    private viewCtrl: ViewController,
    private navParams: NavParams,
    private accessCntrl: AccessControlService
  ) {
    this.config = this.navParams.data.config;
    if (this.config.id === "physician-panel-view") {
      this.id = this.config.id;
      this.revision = this.config.revision;
      this.status = this.config.status;
    }
    if (this.config.id === "volunteer-activity") {
      this.id = this.config.id;
    }
    this.accessCntrl
      .getPermission(PATIENT_ORDER_MANAGEMENT_CLINICAL_ADMIN)
      .subscribe((data) => {
        this.permissionsAccess = data;
      });
  }

  buttonPressed(button) {
    if (button === "deactivate" && this.revision <= 1) {
      button = "discontinue";
    }
    let data = { buttonType: button };
    this.viewCtrl.dismiss(data);
  }

  getAccess(resource: string) {
    return this.accessCntrl.getAccessLevel(this.permissionsAccess, resource);
  }

  isDiscontinueAccess() {
    let isAccess = this.config.orderType == "DG" ? this.getTypeAccess() : true;
    return (
      this.config.orderStatus === "active" &&
      this.config.orderType != "LC" &&
      isAccess
    );
  }
  getTypeAccess() {
    return this.config.item.diagnosisType == "RL";
  }
  isMoveToOpenAccess() {
    let isAccess = this.config.orderType == "DG" ? this.getTypeAccess() : true;
    return (
      this.config.orderStatus === "active" &&
      this.config.orderType != "VF" &&
      this.config.orderType != "LC" &&
      this.getAccess(OrderManagement.PatientOrderManagementEdit) > 0 &&
      isAccess
    );
  }

  isEditAccess() {
    return (
      this.config.orderStatus === "new" ||
      ((this.config.orderStatus === "open-suborder" ||
        this.config.orderStatus === "active") &&
        this.isOrderStatusAccess() &&
        this.getAccess(OrderManagement.PatientOrderManagementEdit) > 0)
    );
  }

  isOrderStatusAccess() {
    let access =
      (this.config.orderStatus === "active" &&
        (this.config.orderType == "LC" ||
          this.config.orderType == "DG" ||
          this.config.orderType == "VF" ||
          this.config.orderType == "OT")) ||
      (this.config.orderStatus === "open-suborder" &&
        this.config.orderType == "VF")
        ? false
        : true;
    return access;
  }
}



// WEBPACK FOOTER //
// ./src/components/orders/order-popup/order-popup.ts